import { configureStore } from '@reduxjs/toolkit'
import reducerKgo from '../../Kgo/reducers/reducer'
import reducerPool from '../../Pool/reducers/poolSlice'
import kgoReducer from '../../Kgo/reducers/kgoReducer'
import storage from 'redux-persist/lib/storage'
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';


import thunk from 'redux-thunk';
// const reducer = {
//     kgoRedux: reducerKgo,
//     poolRedux: reducerPool
//   }
const persistConfig = {
    key: 'root',
    storage,
  }
  
  const reducers = combineReducers({
    reducerPool: reducerPool,
    reducerKgo:reducerKgo,
    reducerKgoPage:persistReducer(persistConfig, kgoReducer) 
  });
 

export const store= configureStore({
    reducer: reducers,
    devTools: process.env.NODE_ENV !== 'production',
    middleware: [thunk],
  });